export default __webpack_public_path__ + "static/media/maisons_laffitte13.126ef102.jpg";